import { Close, CloseOutlined, LinkOutlined } from '@mui/icons-material';
import { Button, Modal } from '@mui/material';
import { Row } from 'antd';
import { find } from 'lodash';
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVideos } from 'store/resources/selectors';
import { useCurrentUser } from 'store/users/selectors';
import styled from 'styled-components';
import COLOR from 'utils/constants/color';
import AssignmentsComponent from '../../../../assignments';
import VideoPlayerWithTranscript from './transcriptButton';

const ResourcePreview = ({ open, handleClose, link, id, extensionActivity, styles }) => {
  const currentUser = useCurrentUser();
  const navigate = useNavigate();
  const videos = useVideos();
  const url = `/video?id=${id}&quiz=null&link=${link}`;

  const videoData = useMemo(() => {
    const videoData = find(videos, ['id', id]) || {};
    return videoData;
  }, [id]);

  const redirectPage = () => {
    handleClose();
    navigate(url);
  };

  return (
    <>
      {currentUser?.role === 'teacher' && open && (
        <StyledModal open={open} onClose={handleClose} className={'lessonPlanPopUp'}>
          <LearnPlanWrapper>
            <LessionPlanContainer>
              <Button
                variant="contained"
                color="primary"
                startIcon={<LinkOutlined />}
                onClick={redirectPage}
                style={{ marginBottom: '10px' }}
              >
                Go to Page
              </Button>
              <CloseBtn
                onClick={() => {
                  handleClose(false);
                }}
              >
                <StyledCloseIcon />
              </CloseBtn>
              <LessonContainer className='LessonContainerCstm'>
                <PrintWrapper className='LessonContainerCstmLeft' isStudent={currentUser?.role === 'student'}>
                  <VideoPlayerWithTranscript videoData={videoData} />
                </PrintWrapper>
                <div className='LessonContainerCstmRght'>
                  <AssignmentsComponent
                    bookId={videoData?.id}
                    pageId={videoData?.id}
                    extensionActivityId={extensionActivity?.id}
                    from={'extensionActivity'}
                    renderAssignments={'admin'}
                  />
                </div>
              </LessonContainer>
            </LessionPlanContainer>
          </LearnPlanWrapper>
        </StyledModal>
      )}

       {currentUser?.role === 'student' && open && (
        <Wrapper
          width={styles.width}
          height={styles.height + 36}
          className={`resourceVdoWraper ${open ? 'main-book-popup printScreenPage setIndexCstm' : ''}`}>
          <Button variant="contained" color="primary" startIcon={<LinkOutlined />} onClick={redirectPage}
            style={{ marginBottom: '10px' }}>Go to Page</Button>
          <CloseButton onClick={handleClose} />
          <HeaderRow style={{ justifyContent: 'center' }}>
            <PrintWrapper isStudent={currentUser?.role === 'student'}>
              <VideoPlayerWithTranscript videoData={videoData} />
            </PrintWrapper>
          </HeaderRow>
        </Wrapper>
      )}
    </>
  );
};

export default ResourcePreview;

const Wrapper = styled.div`
  position: absolute;
  top: 0px;
  width: ${(p) => p.width}px;
  height: ${(p) => p.height}px;
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 2;
  box-shadow:
    7px -3px 26px 20px rgb(66 66 66),
    -4px -3px 26px 15px rgb(95 109 110);
`;

const HeaderRow = styled(Row)`
  minHeight: 47px;
  padding: 5px;
  justify-content: space-between;
  display: flex;
  background-color: ${COLOR.white};
  // padding-right: 20px;
`;

const CloseButton = styled(CloseOutlined)`
  position: absolute;
  top: -10px;
  right: -10px;
  cursor: pointer;
  font-size: 20px;
  color: white;
  background: red;
  padding: 5px;
  border-radius: 50%;
  z-index:99;
`;

const StyledModal = styled(Modal)`
  height: 100%;
  width: 100%;
  background-color: transparent;
  z-index: 1000 !important;
`;

const StyledCloseIcon = styled(Close)`
  color: #fff;
  font-weight: bolder;
  font-size: 25px;
`;

const LearnPlanWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background-color: transparent;
  overflow: hidden;
`;

const LessionPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 90%;
  max-height: 90%;
  width: 90%;
  position: relative;
  padding: 30px 20px 30px;
  background-color: white;
  justify-content: ${(props) => (props.isStudent ? 'center' : 'flex-start')};
  align-items: center;
  overflow-y: scroll;
  
  // @media (max-width: 1024px){
  //   min-height: 600px;
  // }
  // @media (max-width: 990px){
  //   min-height: 550px;
  // }
  // @media (max-width: 800px){
  //   min-height: 450px;
  // }
  // @media (max-width: 700px){
  //   min-height: 400px;
  // }
  // @media (max-width: 600px){
  //   min-height: 350px;
  // }
  // @media (max-width: 450px){
  //   min-height: 480px;
  // }
  
`;

const CloseBtn = styled.div`
  background-color: rgb(204, 80, 71);
  border: none;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  z-index: 1;
`;

const LessonContainer = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  margin: 0px auto;
  padding: 64px 0px 0px;
  position: relative;
  width: 100%;
  justify-content: center;
  align-items: ${(props) => (props.isStudent ? 'center' : 'flex-start')};
  gap: ${(props) => (!props.isStudent ? '10px' : '0px')};
  @media (min-width: 500px) {
    flex-direction: row;
    padding: 0px 30px;
  }
`;

const PrintWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${(props) => (props.isStudent ? '100%' : '50%')};
`;

const Images = styled.img`
  cursor: pointer;
  background-color: ${COLOR.white};
  box-shadow:
    0 10px 20px rgba(0, 0, 0, 0.19),
    0 6px 6px rgba(0, 0, 0, 0.23);
  object-fit: cover;
  max-width: 48%;
`;

const ButtonContainer = styled.button`
  background-color: transparent;
  border: none;
  color: ${COLOR.black600};
  cursor: pointer;
  height: 40px;
  left: ${(p) => `${p.left}px`};
  outline: none;
  position: absolute;
  right: ${(p) => `${p.right}px`};
  top: 50%;
  transition: all 300ms ease;
  width: 40px;
  z-index: 1;
`;
